import styled from 'styled-components';

export const SrpLeftBlockLayoutDiv = styled.div(
  props => `
  position: sticky;
  align-self: flex-end;
  display:flex;
  flex-wrap: wrap;
  width:25%;
  background-color:${props.theme.colors.blue.bgBlue};
  padding-right:${props.theme.spacing.base};
  padding-top:${props.theme.spacing.custom(32)};
  width:100%

`,
);
